export const FORM_ID = 'containers/SignUpForm';
